import { camelize } from 'casing'
import { AxiosError, AxiosResponse } from 'axios'
import {
  errorLogger,
  LoadingTypes,
  startLoading,
  stopLoading,
} from '@labrav/common'
import { fetchResellers } from '../../api/marketplace/index'
import type { AppDispatch, RootState } from '../../store/types'
import type { ResellerInfo } from '../../types/resaleAuthorization'
import { ResellerActions } from './types'

export { ResellerActions }

export const getResellersData =
  (partnerId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.RESELLERS_DATA))
    try {
      const { data } = await fetchResellers(partnerId)
      await dispatch(
        setResellersData(
          camelize(data as { awsResellers?: ResellerInfo[] }).awsResellers
        )
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.RESELLERS_DATA))
    }
  }

export const setResellersData = (resellers: ResellerInfo[]) => ({
  type: ResellerActions.SET_RESELLERS_DATA,
  payload: resellers,
})
